import * as types from './types'

export default {
  [types.SET_SEARCH_TERM](state, text) {
    if (text !== undefined && text !== null) {
      state.searchTerm = text
    }
  },
  [types.SET_PAGE_SIZE](state, value) {
    if (value !== undefined && value !== null) {
      state.pageSize = parseInt(value)
    }
  },
  [types.SET_SORT_DIR](state, text) {
    if (text !== undefined && text !== null) {
      state.sortDir = text
    }
  },
  [types.SET_ORDER_BY](state, text) {
    if (text !== undefined && text !== null) {
      state.orderBy = text
    }
  },
  [types.SET_STATUS](state, value) {
    if (value !== undefined && value !== null) {
      state.status = value
    }
  },
  [types.SET_FILTER_BY](state, value) {
    if (value !== undefined && value !== null) {
      state.filterBy = parseInt(value)
    }
  },
  [types.SET_INTEGRATION](state, data) {
    state.integration = data
    state.currentIntegration = data
  },
  [types.SET_INTEGRATIONS](state, data) {
    state.totalIntegrations = 0
    state.integrations = []
    if (data !== undefined && data !== null) {
      if (data.length > 0) {
        state.totalIntegrations = data[0].totalItems
        for (var item of data) {
          item.isChecked = false
        }
        state.integrations = data
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/integrations/mutations.js